import React, { useEffect } from "react";

import Main from '../components/Bonus/Main'
import UniqueBonuses from "../components/Bonus/UniqueBonuses";
import Faq from "../components/Bonus/Faq";
import YourTradingJourney from "../components/Home/YourTradingJourney";

function Bonus () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#F8F8F8]">
            <Main/>
            <UniqueBonuses/>
            <Faq/>
            <YourTradingJourney/>
        </div>
    );
}

export default Bonus;